import type { PayloadAction } from '@reduxjs/toolkit';

import type { NavigationStateStore } from '../types';
import { pruneStaleNavigationState } from './pruneStale';

export const setState = (
  state: NavigationStateStore,
  action: PayloadAction<{
    key: string;
    data: Record<string, unknown>;
  }>
) => {
  const { key, data } = action.payload;

  pruneStaleNavigationState(state);

  state[key] = {
    data,
    timestamp: Date.now(),
  };
};
